import * as React from 'react';
import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import { Button, Close16 } from '@cian/ui-kit';
import { IWithTrackingProps } from '../../../../../hoc/withTracking';
import { trackAdFoxMortgage } from '../../../../../../tracking/adFoxMortgage';
import { isMortgageCampaign } from '../../../utils/mortgage';

import { UndergroundIcon } from '../../../../../../common/components/underground_icon';

import * as styles from './TGSimplifiedBanner.css';
import { sendAdsEvent } from '../../../../../../tracking/sendAdsEvent';

export interface ITGSimplifiedBannerOwnProps {
  context: IAdFoxBannerContext;
  locationId: number | undefined;
}

export interface ITGSimplifiedBannerState {
  isClosed: boolean;
}

export type TTGSimplifiedBannerProps = IWithTrackingProps & ITGSimplifiedBannerOwnProps;

export class TGSimplifiedBanner extends React.Component<TTGSimplifiedBannerProps, ITGSimplifiedBannerState> {
  public state = {
    isClosed: false,
  };

  public componentDidMount(): void {
    this.track(true);
  }

  public render() {
    if (this.state.isClosed) {
      return <div className={styles['empty']} />;
    }

    const { title, location, description, annotation, imageURL, metro, reference, site } = this.props.context;

    return (
      <div className={styles['container']} onClick={this.onClick}>
        <a href={reference} target="_blank" className={styles['main-link']}>
          <div className={styles['photo-container']}>
            <img className={styles['photo']} src={imageURL} />
          </div>
          <div className={styles['main-content']}>
            <div className={styles['title']}>{title}</div>
            <div className={styles['links-container']}>
              <div className={styles['goto-button-container']}>{this.renderGotoButton()}</div>
              <div className={styles['link-view']}>{site}</div>
            </div>
            <div className={styles['address-container']}>
              {metro ? this.renderMetro() : null}
              <div className={styles['address']}>{location}</div>
            </div>
            <div className={styles['description']}>{description}</div>
          </div>
          <div className={styles['ad-info']}>
            <span className={styles['ad-label']}>Реклама</span>
            {annotation}
          </div>
        </a>
        <button className={styles['close']} aria-label="Закрыть" onClick={this.close}>
          <Close16 />
        </button>
      </div>
    );
  }

  private track = (isShow: boolean) => {
    const {
      tracking: { user, page },
      context: { bannerId, campaignId },
      shouldSendAdsEvent,
      realtyUserId,
    } = this.props;

    if (!isMortgageCampaign(campaignId)) {
      if (shouldSendAdsEvent && !!bannerId) {
        sendAdsEvent({
          realtyUserId,
          action: isShow ? 'show' : 'click',
          bannerId,
          bannerPlace: 'offersSerp',
        });
      }

      return;
    }
    trackAdFoxMortgage(isShow ? 'show' : 'click', 'LinkIpoteka', bannerId, user, page);
  };

  public onClick = () => {
    this.track(false);
  };

  private renderMetro = () => {
    return (
      <div className={styles['metro-container']}>
        {this.props.context['metroColor'] && (
          <div className={styles['metro-icon']}>
            <UndergroundIcon
              width={this.props.locationId ? 16 : 12}
              height={this.props.locationId ? 16 : 14}
              color={`${this.props.context['metroColor']}`}
              regionId={this.props.locationId}
            />
          </div>
        )}
        <div className={styles['metro-name']}>
          {this.props.context['metro']} • <span>{this.props.context['metroDistance']}</span>
        </div>
      </div>
    );
  };

  private renderGotoButton = () => {
    const { button } = this.props.context;
    const buttonTitle = button || 'Узнать подробнее';

    return (
      <Button theme="fill_secondary" size="XS">
        {buttonTitle}
      </Button>
    );
  };

  private close = () => this.setState({ isClosed: true });
}
